const BuoySubmarineList = () => import('Views/buoySubmarine/buoySubmarine-list-new-ui');

export default[
  { path: '/buoy-submarine-list', component: BuoySubmarineList },
  { path: '/buoy-submarine-list/:id', component: BuoySubmarineList },
];



// WEBPACK FOOTER //
// ./src/router/buoySubmarine.js